import React from "react";
import ToolsPaneView from "./tools_pane_view";
import {backgrounds} from "components/tools_pane/tools_items";
import * as uuid from "uuid";

class ToolsPane extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 1,
        }
    }

    render() {
        return <ToolsPaneView
            onTabClick={(i) => this.onTabClick(i)}
            onBgClick={(i) => this.bgClick(i)}
            {...this.state}
            {...this.props}
        />;
    }

    onTabClick(i) {
        console.log(i);
        this.setState({selectedTab: i});
        if (!!this.props.tabChanged) this.props.tabChanged(i);
    }

    bgClick(i) {
        this.props.bgClick(i);
    }


}

export default ToolsPane;